// Names of the query params that are used to attribute a user to a campaign
// as well as our own internal heuristics for attribution based on referrer.

// These are inferred from the referrer header

// The session id
const session_id = 'session_id';

// The exact referrer domain
const referrer = 'referrer';

// The exact URL the user landed on
const landing_page = 'landing_page';

// These are all query parameters that will be added to links for attribution
const utm_campaign = 'utm_campaign';
const utm_source = 'utm_source';
const utm_medium = 'utm_medium';
const utm_content = 'utm_content';
const utm_term = 'utm_term';
const fbclid = 'fbclid';
const ad_id = 'ad_id';
const gclid = 'gclid';
const gc_id = 'gc_id';

export const AttributionParam = {
  session_id,
  referrer,
  landing_page,
  utm_campaign,
  utm_source,
  utm_medium,
  utm_content,
  utm_term,
  fbclid,
  ad_id,
  gclid,
  gc_id,
} as const;

export type AttributionParam = (typeof AttributionParam)[keyof typeof AttributionParam];

export type Attribution = { [key in AttributionParam]?: string };
